import { className } from 'lib/css'
import { useSeamlyApiContext } from 'ui/hooks/seamly-api-hooks'
import { actionTypes } from 'ui/utils/seamly-utils'
import { useEntryAbortTransaction } from '../text-entry/hooks'

export default function AbortTransactionButton() {
  const { abortTransaction, clearEntryAbortTransaction } =
    useEntryAbortTransaction()
  const api = useSeamlyApiContext()

  if (!abortTransaction) return null

  const handleAbortTransaction = () => {
    api.send('action', {
      type: actionTypes.setTopic,
      body: {
        name: abortTransaction.topicName,
        fallbackMessage: abortTransaction.topicFallbackMessage,
      },
    })

    clearEntryAbortTransaction()
  }

  return (
    <li
      className={className([
        'cvco-conversation__item',
        'cvco-conversation__item--abort-transaction',
      ])}
    >
      <button
        className={className([
          'button',
          'button--secondary',
          'abort-transaction__button',
        ])}
        type="button"
        onClick={handleAbortTransaction}
      >
        {abortTransaction.label}
      </button>
    </li>
  )
}
